import { useTranslation } from 'react-i18next';
import capitalize from '~/utils/string';
import Icon from './icon.component';
import OptionsMenu from './options-menu.component';

interface HeaderProps {
  onSignOut: () => void;
}

const Header = ({ onSignOut }: HeaderProps) => {
  const { t } = useTranslation();
  return (
    <div className="w-full flex items-center justify-end p-6 z-10 h-16 backdrop-filter backdrop-saturate-200 backdrop-blur-sm absolute border border-b-1 border-gray-200 bg-gray-100 bg-opacity-70">
      <OptionsMenu menuButton={<Icon name="UserIcon" />}>
        <OptionsMenu.Item icon="LogoutIcon" onClick={onSignOut}>
          {capitalize(t('sign out'))}
        </OptionsMenu.Item>
      </OptionsMenu>
    </div>
  );
};

export default Header;
